import { render } from "./CRMRankingView.vue?vue&type=template&id=dc1865c8&scoped=true"
import script from "./CRMRankingView.vue?vue&type=script&lang=js"
export * from "./CRMRankingView.vue?vue&type=script&lang=js"

import "./CRMRankingView.vue?vue&type=style&index=0&id=dc1865c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc1865c8"]])

export default __exports__